import { FirebaseError } from "firebase/app";
import { capitalize, lowerCase } from "lodash";
export function throwFirebaseError(error: unknown) {
  if (error instanceof FirebaseError) {
    throw new Error(formatFirebaseErrorMessage(error));
  }
  throw error;
}

/**
 * There are times when more helpful error messages are thrown in error.message,
 * and times when `error.message` is just `Error`. This function checks for a meaningful error message
 * and falls back to a sentence cased error code.
 * All `FirebaseError` instance messages are formatted as `Firebase: <error> (<code>).`
 * All error codes are formatted as `auth/<specific-code>`
 */
export function formatFirebaseErrorMessage(error: FirebaseError) {
  const { code, message } = error;

  // remove "Firebase:" and the error code from the message
  const trimmedMessage = message
    .trim()
    .split(":")
    .slice(1)
    .join("")
    .split("(")
    .slice(0, 1)
    .join("")
    .trim();

  if (trimmedMessage === "Error") {
    return `Error: ${capitalize(lowerCase(code.replace("auth/", "")))}`;
  }

  return `Error: ${trimmedMessage}`;
}
